<template>
  <text-highlight
    :queries="highlightTerms"
    highlight-class="yellow darken-1"
  >
    <slot></slot>
  </text-highlight>
</template>

<script>
import TextHighlight from 'vue-text-highlight';

export default {
  name: 'HighlightableContent',
  components: { TextHighlight },
  props: {
    highlightTerms: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
